<template>
      <v-layout row wrap justify-center align-center>
          <v-flex xs12>
              <v-card class='mb-2'>
                  <v-card-title class="text-xs-center" style="font-size: 2rem">
                    Cadastro de projetos padrões
                  </v-card-title>
                  <v-card-text>
                    <v-layout row wrap justify-center align-center>
                      <v-container fluid>
                        <v-form v-model="valid" ref="form" lazy-validation >
                          <v-flex xs12>
                            <v-text-field
                            label="*Nome"
                            v-model="result.name"
                            :rules="[v => !!v || 'Nome é obrigatório']"
                            :counter="100"
                            maxlength="100"
                            required
                            ></v-text-field>
                            <v-textarea
                            name="Descricao"
                            v-model="result.description"
                            label="Descrição"
                            :counter="1200"
                            maxlength="1200"
                            ></v-textarea>
                            <v-textarea
                            name="Objetivo"
                            v-model="result.objetivo"
                            label="Objetivo"
                            :counter="1200"
                            maxlength="1200"
                            ></v-textarea>
                            <v-textarea
                            name="justificativa"
                            v-model="result.justificativa"
                            label="Justificativa"
                            :counter="1200"
                            maxlength="1200"
                            ></v-textarea>
                            <v-textarea
                            name="recursos"
                            v-model="result.recursos"
                            label="Recursos"
                            :counter="1200"
                            maxlength="1200"
                            ></v-textarea>
                            <v-autocomplete
                            label="*Programa"
                            :items="programas"
                            :rules="[v => !v.length < 1|| 'Programa é obrigatório']"
                            item-text="name"
                            item-value="slug"
                            v-model="result.programas"
                            @blur="filtroAno"
                            max-height="400"
                            multiple
                            hint="Escolha o(s) programa(s)"
                            persistent-hint
                            ></v-autocomplete>
                            <v-autocomplete
                              label="*Ano"
                              :items="ano"
                              item-text="name"
                              item-value="name"
                              v-model="result.ano"
                              :rules="[v => !!v || 'Ano é obrigatório']"
                              max-height="400"
                              required
                              hint="Escolha o ano"
                              persistent-hint
                            ></v-autocomplete>
                          </v-flex>
                          <v-layout row wrap >
                            <v-flex xs7 mt-2>
                            <h2 class="mb-1">*Escolha uma imagem para capa do projeto</h2>
                              <input 
                              style="display: none" 
                              type="file"
                              accept="image/*"
                              @change="onFileChanged"
                              ref="SelectFile">
                              <v-btn
                              style="margin-top: 15px"
                              color="blue-grey"
                              @click.native="$refs.SelectFile.click()"
                              class="white--text">
                                Escolher imagem
                                <v-icon right dark>insert_photo</v-icon>
                              </v-btn>
                            </v-flex>
                            <v-flex xs5>
                              <img style="width:50%; height:100%; padding-top: 10px; display: none"  
                              :src="path"
                              id="imagemprojeto"/>
                            </v-flex>
                            <v-flex xs12 mt-3>
                              <h2 class="mb-1">Selecione o plano de atividades</h2>
                              <div >
                                <input 
                                  style="display: none" 
                                  type="file"
                                  accept="application/pdf, application/msword, application/vnd.ms-excel"
                                  @change="onFileChangedFile"
                                  ref="fileSelect">  
                                <v-btn
                                  color="primary"
                                  @click="$refs.fileSelect.click()">   
                                  Anexar          
                                </v-btn >
                              </div>
                            </v-flex>
                            <v-flex v-if="arquivos">
                             <p> <v-icon style="margin-top: 20px" size="36px">attach_file</v-icon> {{fileSelect.name}} </p>
                            </v-flex>
                          </v-layout>
                        </v-form>
                      </v-container>
                    </v-layout>
                  </v-card-text>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary"  @click.native="proximo" >Continuar</v-btn>
                  </v-card-actions>
                  
              </v-card>

              <v-snackbar
              v-model="snackbar"
              bottom
              :color="cor">
              {{ text }}
                <v-btn flat color="black" @click.native="snackbar = false">Close</v-btn>
              </v-snackbar>
            
          </v-flex>
      </v-layout>
</template>

<script>
import api from '@/api'
export default {
  components: {
  },
  data () {
    return {
      currentTab: 'Básico',
      showImageUpload: false,
      imageChangeModal: false,
      selectedFile: {},
      fileSelect: [],
      instruction: {},
      result: {},
      editing: false,
      animation: false,
      tempData: {},
      options: [],
      unidade: [],
      programas: [],
      hasImage: false,
      snackbar: false,
      ano: [],
      path: '',
      text: '',
      cor: '',
      valid: true,
      arquivos: false
    }
  },
  created () {
  },
  mounted () {
    api.request('GET', 'programas/').then(response => {
      this.programas = response.data
    })
    api.request('Get', 'ano/').then(response => {
      response.data.sort((a, b) => (a.order_number > b.order_number) ? 1 : ((b.order_number > a.order_number) ? -1 : 0))
      this.ano = response.data
    })
  },
  computed: {
  },
  methods: {
    proximo () {
      if (this.$refs.form.validate()) {
        if (this.hasImage) {
          this.$emit('dados1', this.result)
          this.$emit('dadoinstruction', this.instruction, this.arquivos)
          this.$emit('dadoimage', this.selectedFile, this.isImage)
          this.$emit('next')
        }
        if (!this.hasImage) {
          this.text = 'Adicione uma imagem para capa do projeto'
          this.cor = 'warning'
          this.snackbar = true
        }
      }
    },
    getUserImage (username) {
      var userarray = this.projetoData.integrantes.filter(value => {
        return value.username === username
      })
      return userarray[0].profilePic
    },
    clear () {
      this.$refs.form.reset()
    },
    filtroAno () {
      console.log(this.result.programas)
      console.log(this.programas)
      var ano = this.programas.forEach(value => {
        return value.name === this.result.programas
      });
      console.log(ano)
    },
    base64 (element) {
      let self = this
      var reader = new FileReader()
      reader.onloadend = function () {
        self.projetoData.image = reader.result
      }
      reader.readAsDataURL(element)
    },
    onFileChanged (event) {
      this.selectedFile = event.target.files[0]
      this.path = URL.createObjectURL(event.target.files[0])
      var image = document.getElementById('imagemprojeto')
      image.style.display = 'block'
      this.hasImage = true
    },
    onFileChangedFile (event) {
      this.arquivos = false
      this.instruction = event.target.files[0]
      this.fileSelect = event.target.files[0]

      this.arquivos = true
    }
  }
}
</script>

<style >

</style>



// WEBPACK FOOTER //
// src/components/pages/Padroes/CadastroSteps/Step1.vue